import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesModalComponent } from './messages-modal.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ChatsModule } from './chats/chats.module';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AvatarModule } from 'src/app/share/avatar/avatar.module';
import { ChatDatetimeModule } from 'src/app/pipe/chat-datetime/chat-datetime.module';
import { ListStatusModule } from 'src/app/share/list-status/list-status.module';
import { TruncateModule } from 'src/app/pipe/truncate/truncate.module';
import { MessagesModule } from './messages/messages.module';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { register } from 'swiper/element/bundle';

register();

@NgModule({
	declarations: [
		MessagesModalComponent
	],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
	exports: [MessagesModalComponent],
	imports: [
		CommonModule,
		FlexLayoutModule,
		FormsModule,
		IonicModule,
		AvatarModule,
		ChatDatetimeModule,
		ListStatusModule,
		TruncateModule,
		ChatsModule,
		MessagesModule
	]
})
export class MessagesModalModule { }
